module.exports = __webpack_public_path__ + "static/media/thumbnail.1f14f9f9.jpg";